module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.verifyShippingRule(_vm.selectedShippingOption) && _vm.announcementConfiguration.shippingFree) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('strong', [_vm._v("Em caso de frete grátis, escolha a regra:")]), _vm._v(" "), (_vm.loading) ? _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.shippingRules), function(shippingRule) {
    return (Object.keys(_vm.shippingRules).length && !_vm.loading) ? _c('div', {
      key: shippingRule,
      staticClass: "l-row"
    }, [_c('form-group', {
      attrs: {
        "label": _vm.getLabel(),
        "columns": 4
      }
    }, [_c('radio-button', {
      attrs: {
        "options": _vm.getShippingRuleOptions(shippingRule),
        "checkedDefault": _vm.shippingRuleSelected,
        "toggleChecked": _vm.onChangeShippingRule,
        "name": _vm.announcementConfiguration.account.identifier
      }
    })], 1), _vm._v(" "), (_vm.shippingRuleSelected === 'exclude_region') ? _c('form-group', {
      attrs: {
        "label": "Regiões não atendidas"
      }
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.regions,
        "selectLabel": "",
        "selectedLabel": "",
        "placeholder": "Escolha",
        "multiple": true
      },
      model: {
        value: (_vm.shippingRuleSelectedRegion),
        callback: function($$v) {
          _vm.shippingRuleSelectedRegion = $$v
        },
        expression: "shippingRuleSelectedRegion"
      }
    })], 1) : _vm._e()], 1) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665c3e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/general/ShippingRules.vue
// module id = 3240
// module chunks = 0